<template>
    <div class="ManualFerramenta">
        <button :class="'btn btn-manual '+(btnClass)" @click="togleModal" v-if="interna">
            {{nameBtn}}
        </button>
        <p v-else @click="togleModal" class="btn btn-manual-interno txt-h-5 txt-size-14 txt-white txt-w-7 txt-letter-n-2 mb-0 position-absolute" style="top: 3px; right: 3px;">
            <i class="fas fa-book"></i>
        </p>

        <div class="modal fade modal-manual-pdf" tabindex="-1" :id="'modal-manual-ferramenta-' + _uid" ref="modalManual">
            <div class="modal-dialog modal-dialog-centered" :class="'modal-' + size">
                <div class="modal-content border-0 bg-transparent">
                    <div class="md-wrapper">
                        <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                                type="button"
                                aria-label="Fechar"
                                @click="hideModalFn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg>
                        </button>

                        <div class="md-header">
                            <div class="md-header__id">
                                <span class="md-header__badge">
                                    <i class="fas fa-file-pdf"></i>
                                    PDF
                                </span>
                                <h2 class="md-header__title">{{ name }}</h2>
                            </div>
                        </div>

                        <div class="md-body">
                            <iframe v-if="showModal && urlPdf"
                                    class="md-pdf-frame"
                                    :src="urlPdf"
                                    :title="name"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Modal',
        props: {
            titulo: String,
            interna: {
                type: Boolean,
                default: true
            },
            size: {
                type: String,
                default: 'xl'
            },
            name: {
                type: String,
                default: 'Manual'
            },
            btnClass: {
                type: String,
                default: ''
            },
            nameBtn: {
                type: String,
                default: 'Manual'
            },
            urlPdf: {
                type: String,
                default: 'manual-usuario.pdf'
            },
        },
        data: function () {
            return {
                showModal: false,
                modalManual: null,
            }
        },
        methods: {
            garantirModal() {
                if (!this.modalManual && this.$refs.modalManual) {
                    this.modalManual = new window.bootstrap.Modal(this.$refs.modalManual)
                }
                return this.modalManual
            },

            onModalHidden() {
                this.showModal = false
            },

            hideModalFn: function () {
                this.garantirModal()?.hide()
            },

            togleModal: function () {
                if (this.showModal) {
                    this.hideModalFn()
                    return
                }

                this.showModal = true
                this.$nextTick(() => {
                    this.garantirModal()?.show()
                })
            },
        },
        mounted() {
            const el = this.$refs.modalManual
            if (el) {
                document.body.appendChild(el)
                el.addEventListener('hidden.bs.modal', this.onModalHidden)
            }
        },
        beforeDestroy() {
            const el = this.$refs.modalManual
            if (el) {
                el.removeEventListener('hidden.bs.modal', this.onModalHidden)
            }
            this.modalManual?.hide()
            this.modalManual?.dispose()
            this.modalManual = null
            if (el && el.parentNode) {
                el.parentNode.removeChild(el)
            }
        },
    };
</script>

<style lang="scss" scoped>
    .btn-manual{
        font-size: 12px;
        padding: 5px 10px;
    }

    .btn-manual-interno {
        padding: 5px 10px;
        background: rgba(0,0,0,0.5);
        display: none;
    }

    .box-modulo:hover {
        .btn-manual-interno {
            display: block;
        }
    }

    .md-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        max-height: calc(100vh - 72px);
        overflow: visible;
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 24px 80px rgba(15, 23, 42, 0.28);
    }

    .btn-close-modern {
        border-radius: 50% !important;
        background: #ffffff !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .btn-close-modern:hover {
        transform: scale(1.05);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .btn-close-modern:hover svg {
        color: #ffffff;
    }

    .md-header {
        display: flex;
        align-items: center;
        gap: 16px;
        flex: none;
        min-height: 66px;
        padding: 12px 24px;
        background: #fff;
        border-bottom: 1px solid #e5e7eb;
        border-radius: 16px 16px 0 0;
    }

    .md-header__id {
        display: flex;
        align-items: center;
        gap: 14px;
        flex: 1;
        min-width: 0;
    }

    .md-header__badge {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        flex: none;
        padding: 5px 10px;
        border: 1px solid rgba(185, 28, 28, 0.2);
        border-radius: 7px;
        background: rgba(220, 53, 69, 0.08);
        color: #b91c1c;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.13em;
        text-transform: uppercase;
    }

    .md-header__title {
        margin: 0;
        font-size: 17px;
        font-weight: 700;
        color: #1f2937;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .md-body {
        flex: 1 1 auto;
        overflow: hidden;
        background: #f8fafc;
        border-radius: 0 0 16px 16px;
        min-height: 520px;
        max-height: calc(100vh - 72px - 66px);
    }

    .md-pdf-frame {
        width: 100%;
        height: calc(100vh - 72px - 66px);
        min-height: 520px;
        border: 0;
        background: #525659;
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

    [data-bs-theme="dark"] .btn-close-modern svg {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .btn-close-modern:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    }

    @media (max-width: 768px) {
        .md-wrapper { max-height: calc(100vh - 32px); }

        .md-header {
            padding: 14px 16px;
        }

        .md-header__title {
            white-space: normal;
            font-size: 16px;
        }
    }
</style>

<style lang="scss">
    .modal-manual-pdf.modal {
        overflow: visible;
        z-index: 1060;
    }

    .modal-manual-pdf .modal-dialog {
        width: 90%;
        max-width: 90vw;
        overflow: visible;
        margin: 36px auto;
    }

    .modal-manual-pdf .modal-content {
        background: transparent;
        border: 0;
        box-shadow: none;
        overflow: visible;
    }

</style>
